import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PositionsTable from '@components/PositionsTable/PositionsTable';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../../src/texts/tooltips';
import Input from '@components/Input';

class SpacingCircleBase extends Component {

  static propTypes = {
    options: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    setCustomCoordinates: PropTypes.func.isRequired
  };

  render() {
    return (
      <div>
        <div className="base-plate__row">
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_SPACING_BETWEEN_AMCHORS.Content}>
            <Input
              className="base-plate__input_block"
              prefix="D ="
              postfix={unitLabel(this.props.unit)}
              id="diameter"
              type="number"
              placeholder="D"
              minValue={0}
              disabled={this.props.specifyCoordinates || 
                (this.props.predefinedBasePlate && this.props.predefinedBasePlate.isPredefinedBasePlate)}
              value={unitTransform(this.props.options.padding.diameter).from(defaultUnits.DISTANCE).to(this.props.unit) || 0}
              onUpdate={this.updateDiameter}
            />
          </Tooltip>
        </div>

        {this.props.options.custom.allow && (
          <div>
            <div className="input-group mt-2 w-25">
              <div className="input-group-prepend">
                <span className="input-group-text">N</span>
              </div>

              <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_FIXINGS.Content}>
              <Input
                id="N"
                type="number"
                placeholder="nb_x"
                minValue={1}
                maxValue={25}
                disabled={this.props.specifyCoordinates}
                value={this.props.options.count.n}
                onUpdate={this.updateScrewCount}
              />
              </Tooltip>
            </div>

            <div className="form-check">
              <label className="form-check-label m-2" htmlFor="specify">
                <input
                  className="form-check-input"
                  id="specify"
                  type="checkbox"
                  checked={this.props.specifyCoordinates}
                  onChange={(e) => {
                    this.updateCustomActive(e.target.checked);
                  }}
                />
                {APP_TEXTS.SPACING_SPECIFY_COORDINATES.Content}
              </label>
            </div>

            <div className="w-50">
              <PositionsTable
                isDisabled={!this.props.specifyCoordinates}
                onUpdate={this.props.onUpdate}
                positions={this.props.options.coordinatesList}
                maxLength={25}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  updateCustomActive(active) {
    if (active === true){
      this.props.onUpdate({
        custom: {
          active,
          positions: this.props.options.coordinatesList
        }
      });
    } else {
      this.props.onUpdate({
        custom: {
          active
        }
      });
    }

    this.props.setCustomCoordinates(active);
  }

  updateScrewCount = (value) => {
    this.props.onUpdate({
      count: {
          n: window.parseInt(value > 25 ? 25 : value)
      }
    });
  };

  updateDiameter = (value) => {
    this.props.onUpdate({
      padding: {
        diameter: unitTransform(+value, false).from(this.props.unit).to(defaultUnits.DISTANCE)
      }
    });
  };

}

const mapState = state => {
  const unit = state.main.units.distance;
  const specifyCoordinates = (state.selectors.dimension[state.main.appType].basePlate && 
    state.selectors.dimension[state.main.appType].basePlate.spacing && 
    state.selectors.dimension[state.main.appType].basePlate.spacing.specifyCoordinates) || false;

  return {
    unit,
    specifyCoordinates,
    predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
  };
};

export default connect(mapState)(SpacingCircleBase);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Spacing/SpacingCircleBase.js